const categoryConfig = {
  'Process Improvement': 'bg-blue-50 text-blue-700 border border-blue-200',
  Automation: 'bg-violet-50 text-violet-700 border border-violet-200',
  'Tool Request': 'bg-amber-50 text-amber-700 border border-amber-200',
  'Data/Reporting': 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  Other: 'bg-slate-100 text-slate-600 border border-slate-200',
}

export default function CategoryBadge({ category }) {
  const cls = categoryConfig[category] || 'bg-slate-100 text-slate-600 border border-slate-200'
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${cls}`}>
      {category}
    </span>
  )
}
